// src/components/ContactUserModal.tsx
import React from 'react'
import Modal from '../../../components/UI/UIModal'
import { Icon } from '../../../components/Icon'
import UIButton from '../../../components/UI/UIButton'

interface ContactUserModalProps {
  isOpen: boolean
  onClose: () => void
}

const ContactUserModal: React.FC<ContactUserModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Modal
      customStyle={{
        borderRadius: 16,
        padding: '20px 16px',
        width: '480px',
      }}
      isOpen={isOpen}
      onClose={onClose}
    >
      <div
        className={
          'max-h-[80vh] min-h-[45vh] items-center p-4 flex flex-col gap-4'
        }
      >
        <div
          onClick={onClose}
          className="flex w-[100%] justify-end cursor-pointer"
        >
          <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
        </div>
        <div className="flex items-center w-[100%] justify-center">
          <Icon
            name={'IconStickerSquare'}
            stroke={'#02698C'}
            strokeWidth={0.5}
            height={56}
            width={56}
          />
        </div>
        <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
          <h1 className={'text-text2 text-lg font-bold leading-6'}>
            {'Contact User'}
          </h1>
          <p className={'text-sm leading-5 text-text1 font-normal'}>
            {' Please select emailing platform'}
          </p>
        </div>
        <div className="w-full flex-col flex gap-4 mt-3"></div>
        <div className="w-full mt-4">
          <UIButton
            onClick={() => window.open('https://gmail.com', '_blank')}
            label={'Gmail'}
          />
        </div>
        <div className="w-full mt-4">
          <UIButton
            onClick={() => window.open('https://outlook.com', '_blank')}
            label={'Outlook'}
          />
        </div>
      </div>
    </Modal>
  )
}

export default ContactUserModal
